import { render } from "./SearchPostByCategoryContent.vue?vue&type=template&id=4a986cda&scoped=true"
import script from "./SearchPostByCategoryContent.vue?vue&type=script&lang=js"
export * from "./SearchPostByCategoryContent.vue?vue&type=script&lang=js"

import "./SearchPostByCategoryContent.vue?vue&type=style&index=0&id=4a986cda&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a986cda"]])

export default __exports__